import $ from 'jquery';
import BaseView from '../../core/baseView';
import * as registry from '../../../home24/core/registry';
export default BaseView.extend({
  events: {
    'click #next': 'onNextClick'
  },

  /**
   * @type {Step1OrdersListView}
   */
  orderList: null,

  /**
   * @type {Step1UploadView}
   */
  uploadView: null,

  /**
   * @type {Step1Model}
   */
  model: null,

  messageBox: null,

  initialize: function(options) {
    this.orderList = options.orderList;
    this.uploadView = options.uploadView;
    this.messageBox = options.messageBox;
  },

  onNextClick: function() {
    var validationResult;

    this.orderList.buildModelFromView();

    validationResult = this.model.validate();

    this.messageBox.clear();

    if (validationResult !== true) {
      /*
       * There was a validation error
       */
      this.messageBox.addError(validationResult);
    } else {
      /*
       * update model with data from UploadView
       */
      this.uploadView.updateModelFromView();

      /*
       * Order list is valid, so we can create new virtual form and submit it
       */
      this.$el.append(this.buildForm());
      this.$('#virtualSubmitForm').submit();
    }
    this.messageBox.render();
  },

  /**
   * Method build form representation of model to send it via POST request to get to next step
   */
  buildForm: function() {
    /*
        Create empty form
         */
    var $form = $(
      '<form id="virtualSubmitForm" method="post" action="' +
        registry.get('submitUrl') +
        '"></form>'
    );

    var sHtml = '';
    var aList = this.model.get('articles');
    var oItem;

    /*
        Iterate over model and render all the fields
         */
    for (var i in aList) {
      /* istanbul ignore else */
      if (aList.hasOwnProperty(i)) {
        oItem = aList[i];
        sHtml +=
          '<input type="hidden" name="article[' +
          oItem.sku +
          '][quantity]" value="' +
          oItem.quantity +
          '" />';
        sHtml +=
          '<input type="hidden" name="article[' +
          oItem.sku +
          '][relatedSku]" value="' +
          oItem.relatedSku +
          '" />';
      }
    }

    sHtml +=
      '<input type="hidden" name="chosen_order_number" value="' +
      this.model.get('orderId') +
      '" />';
    sHtml +=
      '<input type="hidden" name="comment" value="' +
      this.model
        .get('comment')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;') +
      '"/>';

    $form.append(sHtml);

    return $form;
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc2/Step1Controller.js
 **/